export { default as SearchPage } from './Search/SearchPage'
export { default as SearchVendor } from './Search/SearchVendor'
export { default as Sidebar } from './Sidebar'
export { default as StoreInfo } from './StoreInfo'
export { default as NotFound } from './NotFound'
export { default as SearchTitle } from './SearchTitle'
export { default as SearchPlaceHolder } from './SearchPlaceHolder'
export { default as ShowCase } from './Search/ShowCase'



// WEBPACK FOOTER //
// ./src/Catalog/Search/index.js